export enum SaveTemplateMode {
  Create,
  Update,
  ConfirmSaveAsNew
}

export const SAVE_TEMPLATE_MODE_LABELS: Record<SaveTemplateMode, string> = {
  [SaveTemplateMode.Create]: 'Save as Template',
  [SaveTemplateMode.Update]: 'Update Template',
  [SaveTemplateMode.ConfirmSaveAsNew]: 'Save as New Template'
};
